import React, { Component } from 'react';
import { cloneDeep } from 'lodash';

import analyticService from 'services/analytics';
import megatableService from '../megatable/megatable-service';
import { getClass } from '../../../utils/component-helpers';

import DropdownMenu from './dropdown-menu';

import './dropdown.scss';

class BaseDropdown extends Component {
	constructor(props) {
		super(props);

		this.dropdownName = '';
		this.AnalyticService = analyticService;
		this.service = megatableService;
	}

	componentDidMount() {
		window.addEventListener('click', (event) => this.handleClickOutside(event));
	}

	componentWillUnmount() {
		window.removeEventListener('click', (event) => this.handleClickOutside(event));
	}

	handleClickOutside(event) {
		if (!this.dropdownDiv || !this.state.opened ||
			this.dropdownDiv.contains(event.target)) return;

		// Dropdowns that do not require save with "Done" button
		if (this.dropdownName === 'availability') {
			this.update();
		}

		this.toggleDropdown(true);
	}

	toggleDropdown(resetUserSelections=false) {
		this.setState((state) => {
			return {
				opened: !state.opened,
				[this.type]: resetUserSelections ? this.props.items : state[this.type],
			};
		}, () => {
			if (this.state.opened) {
				this.AnalyticService.trackEvent(
					this.props.gaEvent.category, 'Click', this.props.gaEvent.label
				);
			}
		});
	}

	resetColumns() {
		this.toggleDropdown(true);
		this.props.resetColumns();
	}

	// TODO: refactor to either single or multi select based on member variable
	select(index, event) {
		event.stopPropagation();

		// Need to make deep copy to prevent mutating state
		const items = this.state[this.type].map((item) => Object.assign({}, item));

		// Keep only one item selected for granularity dropdown
		if (['granularities', 'reconSelections'].includes(this.type)) {
			items.map((item) => {
				item.selected = false;
				return item;
			});
		}

		items[index].selected = !items[index].selected;

		this.setState({
			focusIndex: index,
			[this.type]: items,
		});
	}

	getLabel(items) {
		return items.find((item) => item.selected).label;
	}

	update() {
		/*
		 * Method is overwritten with custom tracking, so
		 * no longer need to track generic dropdown done event.
		 */
	}

	cancel() {
		this.AnalyticService.trackEvent(
			this.props.gaEvent.category, 'Click', `${this.props.gaEvent.label} Cancel`
		);
		this.setState({
			[this.type]: this.props.items,
			...(this.props.statType === 'merch-ed-overview' && {
				activeOnly: this.props.activeOnly,
				reconciledOnly: this.props.reconciledOnly,
			}),
		});
	}

	toggleState(e, field) {
		e.stopPropagation();
		this.setState({
			[field]: !this.state[field],
		});
	}

	updateField(field, value) {
		this.setState({
			[field]: value,
		});
	}

	render() {
		if (this.type === 'granularities' && !this.props.showGraph) return null;

		const isMerchEd = this.props.statType === 'merch-ed-overview';
		const columns = this.state.columns;
		const selectedColumns = columns ?
			columns.filter((column) => column.selected) : [];
		const noResult = columns && !selectedColumns.length ? (
			<div className="no-result">
				{`No ${this.type} selected. Please select ${this.type} to view data.`}
			</div>
		) : null;

		/*
		* Index items, in order to preserve integrity of state
		* TODO: Refactor this to move items out of state
		*/
		const indexedItems = cloneDeep(this.state[this.type]).map((item, index) => {
			item.index = index;
			return item;
		});
		const dropdownMenu = this.state.opened ? (
			<DropdownMenu
				type={this.type}
				items={indexedItems}
				staticFields={this.props.staticFields}
				identifierField={this.identifierField}
				focusIndex={this.state.focusIndex}
				gaEvent={{
					category: this.props.gaEvent.category,
					label: this.props.gaEvent.label,
				}}
				noResult={noResult}
				search={this.hasSearch}
				resetColumns={this.resetColumns.bind(this)}
				select={this.select.bind(this)}
				update={this.update.bind(this)}
				cancel={this.cancel.bind(this)}
				miscDropdownContent={this.props.miscDropdownContent}
				hideSubmitButtons={this.props.hideSubmitButtons}
				statType={this.props.statType}
				activeOnly={this.state.activeOnly}
				reconciledOnly={this.state.reconciledOnly}
				{...(this.type === 'reconSelections' && {
					reconAction: this.state.reconAction,
					someReconciled: this.props.someReconciled,
					showEditGuardrails: this.state.showEditGuardrails,
					guardrailLowerBound: this.state.guardrailLowerBound,
					guardrailUpperBound: this.state.guardrailUpperBound,
				})}
				updateField={this.updateField.bind(this)}
				toggleState={this.toggleState.bind(this)}
				setLabel={(label) => this.setState({label})}
				label={this.state.label}
				allSelected={this.props.allSelected}
				numSelected={this.props.numSelected}
			/>
		) : null;

		const searchIcon = isMerchEd && this.type === 'merchants' ? (
			<div className="search-icon"></div>
		) : null;

		return (
			<div
				ref={(node) => this.dropdownDiv = node}
				className={getClass(`${this.type}-dropdown`, {
					'merch-ed': isMerchEd,
				})}
				onClick={this.toggleDropdown.bind(this)}>
				<button className={getClass('dropdown-btn', {
					'no-results': this.props.disabled,
					'opened': this.state.opened,
				})}>
					<span className={getClass('dropdown-label', {
						'has-query': isMerchEd
							&& this.state.label !== 'Search for a merchant...'
							&& this.type === 'merchants',
					})}>
						{searchIcon}
						{this.state.label || this.label}
					</span>
					<span className={this.state.opened ? 'arrow-up' : 'arrow-down'}></span>
				</button>

				{dropdownMenu}
			</div>
		);
	}
}

export default BaseDropdown;
